import { render, staticRenderFns } from "./CalendarListEvents.vue?vue&type=template&id=53225e32&scoped=true"
import script from "./CalendarListEvents.vue?vue&type=script&lang=js"
export * from "./CalendarListEvents.vue?vue&type=script&lang=js"
import style0 from "./CalendarListEvents.vue?vue&type=style&index=0&id=53225e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53225e32",
  null
  
)

export default component.exports